// removed by extract-text-webpack-plugin
module.exports = {"header":"_3BgrllUJ_71tzvfslL7Rfo","inner":"mIB_2yGgkSFxMY4swPgOz","filters":"_1Q24944j9lxRt3y3eYaD7H","list-outer":"_2kzKpygJPXhjIbW4CZNzSQ","list":"_3vAhThcPVJJi2RGoOZ2oSB","searching":"_2qNBKiNBJskgH_Uzn2GQJD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PressReleaseBlock/PressReleaseBlock.module.scss
// module id = 795
// module chunks = 0